import React from 'react';

const StatusFirst = ({ color = '#222222' }: { color?: string }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 21.8408L7.4 21.4408C7.45986 21.3809 7.48978 21.351 7.51473 21.3253C9.40033 19.3849 9.40033 16.2966 7.51473 14.3563C7.48978 14.3306 7.45985 14.3006 7.4 14.2408L7 13.8408M17 21.8408L16.6 21.4408C16.5401 21.3809 16.5102 21.351 16.4853 21.3253C14.5997 19.3849 14.5997 16.2966 16.4853 14.3563C16.5102 14.3306 16.5401 14.3006 16.6 14.2408L17 13.8408M2.5091 14.9015C2.66617 14.8618 2.83063 14.8408 3 14.8408C4.10457 14.8408 5 15.7362 5 16.8408V18.8408C5 19.9454 4.10457 20.8408 3 20.8408C1.89543 20.8408 1 19.9454 1 18.8408V16.8408C1 15.9056 1.64187 15.1203 2.5091 14.9015ZM2.5091 14.9015L2.39658 14.1514C1.61838 8.9633 5.10139 4.09509 10.2629 3.15664C11.4115 2.94779 12.5885 2.94779 13.7371 3.15664C18.8986 4.09509 22.3816 8.9633 21.6034 14.1514L21.4909 14.9015M21.4909 14.9015C21.3338 14.8618 21.1694 14.8408 21 14.8408C19.8954 14.8408 19 15.7362 19 16.8408V18.8408C19 19.9454 19.8954 20.8408 21 20.8408C22.1046 20.8408 23 19.9454 23 18.8408V16.8408C23 15.9056 22.3581 15.1203 21.4909 14.9015Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default StatusFirst;
